import Reveal from './Reveal.jsx';
import { ABOUT_POINTS } from '../data/site.js';

export default function About() {
  return (
    <section id="about" className="about">
      <div className="container">
        <div className="about-grid">
          <Reveal className="about-visual">
            <div className="about-img-wrap">
              <div className="about-img-main">
                <div className="about-img-inner">
                  <div className="about-emoji">🦷</div>
                  <p>Kanaga Dental Clinic</p>
                </div>
              </div>
              <div className="about-badge">
                <strong>2</strong>
                <span>Locations</span>
              </div>
            </div>
          </Reveal>

          <Reveal className="about-content" delay={80}>
            <div className="section-label">About Us</div>
            <h2 className="section-title">
              More Than a Clinic —<br />A Place You Can Trust
            </h2>
            <p className="about-text">
              At Kanaga Dental Clinic, we believe every patient deserves personalized, compassionate
              dental care in an environment that feels comfortable and welcoming. From your very first
              visit, our goal is to make you feel completely at ease.
            </p>
            <p className="about-text">
              We focus on more than just treating dental issues — we help our patients build lasting
              oral health habits and maintain the confident smiles they deserve. Our dedicated team
              brings warmth and expertise to every appointment.
            </p>
            <div className="about-points">
              {ABOUT_POINTS.map((point) => (
                <div className="about-point" key={point}>
                  <div className="ap-check">✓</div>
                  <span>{point}</span>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
